import styled from 'styled-components';
import { headLine1 } from '../../theme/GlobalStyle';

export const BannerContainer = styled.div`
  width: 100%;
  height: ${(props) => (props.playbookNewsletter ? '304px' : '350px')};
  position: relative;
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    z-index: 3;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  div {
    height: 100%;
    width: 100%;
  }
  .banner_title {
    width: ${(props) => (props.playbookNewsletter ? '70%' : '100%')};
    text-align: center;
    position: absolute;
    z-index: 4;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${(props) => props.theme.color.white};
    ${headLine1}
  }
  img {
    width: 100%;
    height: 100% !important;
  }
  @media (max-width: 840px) {
    height: 326px;
  }
`;
